var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    { attrs: { view: "hHh Lpr lFf" } },
    [
      _c(
        "q-layout-header",
        [
          _c("notification-bar"),
          _c("accessibility-menu"),
          _c(
            "simple-header-tool-bar",
            _vm._b(
              {
                on: {
                  openMenu: function($event) {
                    _vm.leftDrawerOpen = !_vm.leftDrawerOpen
                  }
                }
              },
              "simple-header-tool-bar",
              _vm.headerToolBarBinds,
              false
            ),
            [
              _vm.buttonIcon
                ? _c("q-btn", {
                    attrs: {
                      slot: "buttons",
                      "data-test": _vm.CypressTarget("Menu"),
                      flat: "",
                      sparse: "",
                      icon: _vm.buttonIcon
                    },
                    on: {
                      click: function($event) {
                        _vm.helpModal = true
                      }
                    },
                    slot: "buttons"
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-page-container",
        { style: _vm.__cordovaFixQPageContainerStyle },
        [_c("router-view")],
        1
      ),
      _c(
        "q-layout-drawer",
        {
          attrs: { "content-class": "bg-grey-2" },
          model: {
            value: _vm.leftDrawerOpen,
            callback: function($$v) {
              _vm.leftDrawerOpen = $$v
            },
            expression: "leftDrawerOpen"
          }
        },
        [
          _c(
            "main-menu",
            _vm._b(
              { on: { logout: _vm.logoutUserFromSite } },
              "main-menu",
              _vm.MainMenuBinds,
              false
            )
          )
        ],
        1
      ),
      _c("active-component-common-modal-help-faq", {
        model: {
          value: _vm.helpModal,
          callback: function($$v) {
            _vm.helpModal = $$v
          },
          expression: "helpModal"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }